export default __webpack_public_path__ + "static/media/barnesBtnDisab.5f9913a9.png";